const replacer = (_, value) => (value === null || value === undefined ? "" : value);

function escapeCell(value) {
  if (value === null || value === undefined) return '""';
  const str =
    typeof value === "object"
      ? JSON.stringify(value, replacer)
      : String(value);
  return '"' + str.replace(/"/g, '""') + '"';
}

/**
 * columns: Array of { key: string, label: string, format?: (value, row) => string }
 * Nested objects/arrays are JSON-stringified by default unless a format fn is provided.
 */
export function downloadCSV(rows, columns, filename) {
  const header = columns.map((col) => escapeCell(col.label)).join(",");
  const dataRows = rows.map((row) =>
    columns
      .map((col) => {
        const value = row[col.key];
        if (col.format) return escapeCell(col.format(value, row));
        if (value !== null && value !== undefined && typeof value === "object")
          return escapeCell(JSON.stringify(value, replacer));
        return escapeCell(value);
      })
      .join(",")
  );
  const csv = [header, ...dataRows].join("\r\n");
  const blob = new Blob(["\ufeff", csv], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : filename + ".csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
